import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { message } from 'antd';
import moment from 'moment';
import { getManagerLeads, getManagerLeadsCount } from '../../requests/get_manager_leads_request';
import {
    getManagerLeadsSuccess,
    getManagerLeadsFailure,
    countManagerLeadsSuccess,
    countManagerLeadsFailure,
    setManagerLeadManageKey,
    setManagerLeadManageLoading, setManagerLeadManageNewKey,
} from '../actions/get_manager_leads.actions';
import { SET_MANAGER_LEAD_MANAGE_PAGINATION } from '../constants/get_manager_leads.constants';
import { extend } from '../../../../../shared/helpers';


function* setManagerLeadManagePaginationRequest() {
    yield put(setManagerLeadManageLoading(true));

    const lead_manage_where = yield select(state => state.ManagerLeads.Manager_leads_manage.where);
    const lead_manage_pagination = yield select(state => state.ManagerLeads.Manager_leads_manage.pagination);
    const newFilters = yield select(state => state.ManagerLeads.Manager_leads_manage.filters);

    if (lead_manage_where.ref_lead_customer === null || lead_manage_where.ref_bike_lead === null) {
        yield put(countManagerLeadsSuccess(0));
        yield put(getManagerLeadsSuccess([]));
    } else {
        const leads = yield call(getManagerLeads, lead_manage_where, lead_manage_pagination);


        if (leads.result) {
            if (leads.options.length === 0) {
                yield put(countManagerLeadsSuccess(0));
                yield put(getManagerLeadsSuccess([]));
            } else {
                let newResults = leads.options;
                newResults = leads.options.filter(e => e.valuations && e.valuations.length > 0 && new moment().subtract(8, 'days').isAfter(new moment(e.valuations[e.valuations.length - 1].created_date)) && new moment().subtract(31, 'days').isBefore(new moment(e.valuations[e.valuations.length - 1].created_date)));

                if (newFilters && newFilters.dateFrom && newFilters.dateTo) {
                    newResults = leads.options.filter(e => e.valuations.length > 0 && e.valuations[e.valuations.length - 1] && new moment(e.valuations[e.valuations.length - 1].created_date).isBetween(newFilters.dateFrom, newFilters.dateTo));
                }

                if (newFilters && newFilters.marginFrom && newFilters.marginTo) {
                    newResults = leads.options.filter(e => e.valuations.length > 0 && e.valuations[e.valuations.length - 1] && ((e.valuations[e.valuations.length - 1].retail_price - e.customer_valuation) >= parseFloat(newFilters.marginFrom)) && ((e.valuations[e.valuations.length - 1].retail_price - e.customer_valuation) <= parseFloat(newFilters.marginTo)));
                }

                yield put(countManagerLeadsSuccess(newResults.length));
                yield put(getManagerLeadsSuccess(newResults));
            }
        } else {
            if (leads.error && leads.error.kind === 'number') {
                message.error('Value must be number');
            } else {
                message.error(leads.error.message);
            }
            yield put(countManagerLeadsSuccess(0));
            yield put(getManagerLeadsFailure(leads.error));
        }
    }

    yield put(setManagerLeadManageLoading(false));
}

export default function* setManagerLeadManagePaginationSaga() {
    yield takeEvery(SET_MANAGER_LEAD_MANAGE_PAGINATION, setManagerLeadManagePaginationRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/sagas/set_manager_lead_manage_pagination.saga.js